(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5894],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 78397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[regionUrlKey]/[placeUrlKey]/[storeUrlKey]",
      function () {
        return __webpack_require__(86176);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores_StoreSchedule; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/every.js
var every = __webpack_require__(711);
var every_default = /*#__PURE__*/__webpack_require__.n(every);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(49474);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/closestIndexTo/index.js
var closestIndexTo = __webpack_require__(85573);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ro/index.js + 5 modules
var ro = __webpack_require__(88397);
;// CONCATENATED MODULE: ./components/Stores/StoreSpecialSchedule.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var StoreSpecialSchedule = function(param1) {
    var schedule1 = param1.schedule;
    // TODO: We should use setDefaultOptions to set global defaults for date-fns
    var currentDate = new Date();
    var scheduleDateFormat = "d MMMM";
    var scheduleDateParseOptions = {
        locale: ro/* default */.Z
    };
    var parsedSchedule = Object.entries(schedule1).map(function(param) {
        var _param = _slicedToArray(param, 2), date = _param[0], openHours = _param[1];
        var dateObject;
        var isValidDate = false;
        try {
            // The schedule date doesn't contain the year
            // Use the current year to set year context
            var currentYearScheduleDate = (0,parse["default"])(date, scheduleDateFormat, currentDate, scheduleDateParseOptions);
            isValidDate = (0,isValid["default"])(currentYearScheduleDate);
            if (isValidDate) {
                // Guess the schedule date year
                var nextYearScheduleDate = (0,add/* default */.Z)(currentYearScheduleDate, {
                    years: 1
                });
                dateObject = (0,closestIndexTo/* default */.Z)(currentDate, [
                    currentYearScheduleDate,
                    nextYearScheduleDate, 
                ]) === 0 ? currentYearScheduleDate : nextYearScheduleDate;
            }
        } catch (error) {
            ;
        }
        return {
            date: date,
            openHours: openHours,
            dateObject: dateObject,
            isValidDate: isValidDate
        };
    });
    var isValidSchedule = every_default()(parsedSchedule, function(schedule) {
        return schedule.isValidDate;
    });
    var sortedSchedule = isValidSchedule && parsedSchedule.sort(function(scheduleA, scheduleB) {
        return (0,compareAsc/* default */.Z)(scheduleA.dateObject, scheduleB.dateObject);
    });
    if (!isValidSchedule) return null;
    return sortedSchedule.map(function(param, index) {
        var date = param.date, openHours = param.openHours;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-medium mr-1",
                    children: [
                        date,
                        ":"
                    ]
                }),
                " ",
                openHours
            ]
        }, index);
    });
};
/* harmony default export */ var Stores_StoreSpecialSchedule = (StoreSpecialSchedule);

// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/Stores/StoreSchedule.js



var StoreSchedule = function(param) {
    var schedule = param.schedule, special_schedule = param.special_schedule;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "mt-3",
        children: [
            special_schedule && Object.keys(special_schedule).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 text-red-brand",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_StoreSpecialSchedule, {
                    schedule: special_schedule
                })
            }),
            schedule && schedule.length !== 0 && (0,helpers/* getStoreCombinedSchedule */.ne)(schedule).map(function(day, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-medium mr-1",
                            children: day.endDay ? "".concat(day.startDay, " — ").concat(day.endDay, ": ") : "".concat(day.startDay, ": ")
                        }),
                        day.openHours
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var Stores_StoreSchedule = (StoreSchedule);


/***/ }),

/***/ 37497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stores_StoresLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/Stores/RegionsBox.js





var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var RegionsBox = function(param) {
    var regions = param.regions;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "border border-transparent rounded-tr-xl rounded-bl-xl stores-image p-6 lg:px-16 lg:pt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex flex-wrap text-left font-normal leading-4 m-0 p-0 -ml-3",
            children: regions.map(function(region) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "w-1/2 sm:w-1/4 md:w-1/5 pl-3 lg:leading-23.4 leading-28.6 -tracking-0.33",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(settings.baseUrl, "/magazine/").concat(region.url_key, "/"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: "Magazinele ".concat(websiteTitle, " din ").concat(region.name),
                            children: region.name
                        })
                    })
                }, region.id));
            })
        })
    });
};
RegionsBox.propTypes = {
    regions: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired
    }).isRequired)
};
/* harmony default export */ var Stores_RegionsBox = (RegionsBox);

;// CONCATENATED MODULE: ./components/Stores/StoresLayout.js






var StoresLayout_ref = (0,config["default"])(), StoresLayout_publicRuntimeConfig = StoresLayout_ref.publicRuntimeConfig, StoresLayout_websiteTitle = StoresLayout_publicRuntimeConfig.content.websiteTitle, websiteStatics = StoresLayout_publicRuntimeConfig.settings.websiteStatics;
var StoresLayout = function(param) {
    var children = param.children, title = param.title, regions = param.regions;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "lg:pt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                title: title,
                as: "h1",
                display: "h1",
                classesProp: "text-left mb-2 mt-4 lg:mt-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-3 pr-8 text-justify text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-0 leading-22 lg:leading-20 -tracking-0.39",
                            children: "Prin reteaua nationala de magazine, ".concat(StoresLayout_websiteTitle, " iti ofera o gama variata de produse, la cele mai avantajoase preturi, sustinute de solutii optime de finantare, adaptate fiecarui tip de buget.")
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                title: "Vezi magazinele ".concat(StoresLayout_websiteTitle, " din regiune"),
                as: "h1",
                display: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_RegionsBox, {
                    regions: regions
                })
            })
        ]
    }));
};
StoresLayout.prototype = {
    children: (prop_types_default()).node.isRequired,
    title: (prop_types_default()).string.isRequired,
    regions: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Stores_StoresLayout = (StoresLayout);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 86176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _storeUrlKey_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./store/user/actions.js
var actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./store/stores/actions.js
var stores_actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./store/support/actions.js
var support_actions = __webpack_require__(3697);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./containers/Support/Layout.js + 1 modules
var Layout = __webpack_require__(72998);
// EXTERNAL MODULE: ./components/Stores/StoresLayout.js + 1 modules
var StoresLayout = __webpack_require__(37497);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Stores/StoreMap.js



var StoreMap = function(param) {
    var latitude = param.latitude, longitude = param.longitude, name = param.name, address = param.address;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: latitude && longitude && name && address ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-6 u-embed u-embed--16p9",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                // Howly smokes longline
                src: "https://maps.google.com/maps?width=100%&height=600&hl=ro&coord=".concat(latitude, ",").concat(longitude, "&q=").concat(encodeURIComponent(address), "+").concat(encodeURIComponent(name), "&ie=UTF8&t=&z=15&iwloc=B&output=embed"),
                allowFullScreen: true
            })
        }) : null
    });
};
StoreMap.propTypes = {
    latitude: (prop_types_default()).string.isRequired,
    longitude: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired,
    address: (prop_types_default()).string.isRequired
};
/* harmony default export */ var Stores_StoreMap = (StoreMap);

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Stores/StoreSchedule.js + 1 modules
var StoreSchedule = __webpack_require__(97988);
;// CONCATENATED MODULE: ./containers/Stores/Store.js






var StoreContainer = function(param) {
    var store = param.store;
    var name = store.name, address = store.address, managerfFirstName = store.first_name, managerLastName = store.last_name, phoneNumber = store.phone, schedule = store.schedule, special_schedule = store.special_schedule, geoPositionLatitude = store.latitude, geoPositionLongitude = store.longitude;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores_StoreMap, {
                latitude: geoPositionLatitude,
                longitude: geoPositionLongitude,
                name: name,
                address: address
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8 sm:flex sm:flex-wrap -mx-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/3 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: name,
                                classesProp: "-tracking-0.48 lg:-tracking-0.5",
                                as: "h2",
                                display: "h2"
                            }),
                            address && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33",
                                children: address
                            })
                        ]
                    }),
                    schedule && schedule.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/3 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Program de lucru",
                                classesProp: "-tracking-0.48 lg:-tracking-0.5",
                                as: "h2",
                                display: "h2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSchedule/* default */.Z, {
                                    schedule: schedule,
                                    special_schedule: special_schedule
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/3 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Contact",
                                classesProp: "-tracking-0.48 lg:-tracking-0.5",
                                as: "h2",
                                display: "h2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33",
                                children: [
                                    managerfFirstName && managerLastName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "m-0 mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-medium mr-1",
                                                children: [
                                                    "Telefon",
                                                    ":"
                                                ]
                                            }),
                                            " ".concat(phoneNumber)
                                        ]
                                    }),
                                    phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "m-0 mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-medium mr-1",
                                                children: [
                                                    "Manager",
                                                    ":"
                                                ]
                                            }),
                                            " ".concat(managerfFirstName, " ").concat(managerLastName)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
StoreContainer.propTypes = {
    store: prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        address: (prop_types_default()).string.isRequired,
        first_name: (prop_types_default()).string,
        last_name: (prop_types_default()).string,
        phoneNumber: (prop_types_default()).string,
        schedule: (prop_types_default()).array
    })
};
/* harmony default export */ var Store = (StoreContainer);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
;// CONCATENATED MODULE: ./pages/magazine/[regionUrlKey]/[placeUrlKey]/[storeUrlKey].js















function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var StorePage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(StorePage, Component1);
    var _super = _createSuper(StorePage);
    function StorePage() {
        _classCallCheck(this, StorePage);
        return _super.apply(this, arguments);
    }
    _createClass(StorePage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, store = _props.store, regions = _props.regions, stores = _props.stores, supportCategories = _props.supportCategories;
                // Check store data
                if (!store || !regions) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                        children: "Nu au fost gasite magazine"
                    }));
                }
                // Find store region name
                var storeRegion = regions.find(function(region) {
                    return store.region_id === region.id;
                });
                var regionsList = (0,helpers/* getRegionsWithStores */.Ly)({
                    regions: regions,
                    stores: stores
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                                children: [
                                    "Magazin ",
                                    store.name
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            className: "pt-3",
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 2,
                                    name: "Suport clienti",
                                    url_key: "suport-clienti/"
                                },
                                {
                                    id: 2,
                                    level: 3,
                                    name: "Magazine",
                                    url_key: "magazine/"
                                },
                                {
                                    id: 3,
                                    level: 3,
                                    name: storeRegion.name,
                                    url_key: "magazine/".concat(storeRegion.url_key, "/")
                                },
                                {
                                    id: 4,
                                    level: 99,
                                    name: store.name
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            categories: supportCategories,
                            back: {
                                title: "Inapoi la lista magazine",
                                slug: "/magazine/"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresLayout/* default */.Z, {
                                title: store.name,
                                regions: regionsList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Store, {
                                    store: store
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return StorePage;
}(react.Component);
StorePage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, query, regionUrlKey, placeUrlKey, storeUrlKey, categories, regions, stores, currentStoreInReduxStore, queryUrlPathStore, promises, urlKeyInCurrentStore;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore, query = ctx.query;
                    regionUrlKey = query.regionUrlKey, placeUrlKey = query.placeUrlKey, storeUrlKey = query.storeUrlKey;
                    categories = reduxStore.getState().support.categories;
                    regions = reduxStore.getState().user.regions;
                    stores = reduxStore.getState().stores;
                    currentStoreInReduxStore = reduxStore.getState().stores.currentStore;
                    queryUrlPathStore = "".concat(regionUrlKey, "/").concat(placeUrlKey, "/").concat(storeUrlKey);
                    promises = [];
                    // Load region data
                    !categories && promises.push(reduxStore.dispatch((0,support_actions/* getSupportCategories */.eU)()));
                    !regions && promises.push(reduxStore.dispatch((0,actions/* getRegions */.JL)()));
                    !stores.data && promises.push(reduxStore.dispatch((0,stores_actions/* getStores */.r8)()));
                    urlKeyInCurrentStore = currentStoreInReduxStore && currentStoreInReduxStore.url_key;
                    if (queryUrlPathStore !== urlKeyInCurrentStore) {
                        promises.push(reduxStore.dispatch((0,stores_actions/* getStoreByUrlPath */.y3)(queryUrlPathStore)));
                    }
                    _ctx.next = 15;
                    return Promise.all(promises);
                case 15:
                    return _ctx.abrupt("return", {
                        regionUrlKey: regionUrlKey,
                        placeUrlKey: placeUrlKey,
                        storeUrlKey: storeUrlKey
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
StorePage.pageLayout = "default";
StorePage.layoutProps = {
    displaySearch: false
};
/* harmony default export */ var _storeUrlKey_ = ((0,withRouterPageLayout/* default */.Z)((0,es/* connect */.$j)(function(state) {
    return {
        stores: state.stores.data,
        regions: state.user.regions,
        store: state.stores.currentStore,
        supportCategories: state.support.categories
    };
})(StorePage)));


/***/ }),

/***/ 76208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r8": function() { return /* binding */ getStores; },
/* harmony export */   "y3": function() { return /* binding */ getStoreByUrlPath; },
/* harmony export */   "MM": function() { return /* binding */ getLockersList; }
/* harmony export */ });
/* unused harmony export getUserLocation */
/* harmony import */ var _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69170);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);




var getStores = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES */ .lc,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_SUCCESS */ .B6,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_FAILURE */ .Md
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            // spinnerMessage: "Loading stores list",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoresApi */ .n5p,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.stores;
            }
        });
    };
};
var getStoreByUrlPath = function(urlPath) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH */ .fw,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_SUCCESS */ .F0,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_FAILURE */ .o8
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se incarca lista magazinelor",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoreByUrlPathApi */ .XM9,
            apiArgs: [
                encodeURIComponent(urlPath)
            ],
            formatResponse: function(response) {
                return {
                    store: response.data.stores[0]
                };
            }
        });
    };
};
var getUserLocation = function() {
    return function(dispatch) {
        // Dispatch get user location action
        dispatch({
            type: GET_USER_LOCATION
        });
        // Check if browser has geolocation support and is enabled
        getBrowserGeolocation().then(function(result) {
            dispatch({
                type: GET_USER_LOCATION_SUCCESS,
                payload: result
            });
        }).catch(function(error) {
            // Catch error and dispatch get user location failure
            dispatch({
                type: GET_USER_LOCATION_FAILURE,
                error: error.message
            });
        });
    };
};
var getLockersList = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST */ .nv,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_SUCCESS */ .DP,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_FAILURE */ .IM
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getLockersApi */ .p5Y,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.data.lockers;
            }
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8208,5337,5202,1223,9774,2888,179], function() { return __webpack_exec__(78397); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);